import { render, staticRenderFns } from "./panel_top.vue?vue&type=template&id=507c4d6d&scoped=true&"
import script from "./panel_top.vue?vue&type=script&lang=js&"
export * from "./panel_top.vue?vue&type=script&lang=js&"
import style0 from "./panel_top.vue?vue&type=style&index=0&id=507c4d6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507c4d6d",
  null
  
)

export default component.exports